import { nanoid } from 'nanoid';
import { INSTALATION_ID_STORAGE_KEY } from '../constants/global';
import config from '../jsons/config.json';

//vrací adresu BE na základě aktuální adresy, kde beží FE. Pro localhost se doplní DEV URL
export const getApiUrl = (protocol: string, path: string) => {
    const scriptUrl = (document as any).currentScript?.src;
    let origin = new URL(scriptUrl);
    origin.pathname = '/';

    if (origin.toString() === 'http://localhost:3000/') {
        origin = new URL(config.apiDevelopmentURL);
    }

    origin.protocol = protocol;
    origin.pathname = path;

    return origin.toString();
}

//vrací jedinečné instalation id
export const getInstalationId = () => {
    const id = localStorage.getItem(INSTALATION_ID_STORAGE_KEY);

    if (id) return id;
    else {
        const newId = nanoid();
        localStorage.setItem(INSTALATION_ID_STORAGE_KEY, newId);
        return newId;
    }
};